import Config from 'react-native-config';

import { RootState, RootDispatch } from 'store/types';
import * as profileSelectors from 'store/profile/selectors';

import { KEY } from '../types';
import { ProviderSuggestionsPayload } from './types';

export const PROVIDER_SUGGESTIONS = `${KEY}.PROVIDER_SUGGESTIONS`;
export const PROVIDER_SUGGESTIONS_FAIL = `${KEY}.PROVIDER_SUGGESTIONS_FAIL`;
export const PROVIDER_SUGGESTIONS_SUCCESS = `${KEY}.PROVIDER_SUGGESTIONS_SUCCESS`;

export const providerSuggestions = (payload: ProviderSuggestionsPayload) => (
  dispatch: RootDispatch,
  getState: () => RootState
) => {
  const isSelectHealth = profileSelectors.isSelectHealthMemberSelector(getState());
  const input = encodeURI(payload.input.trim());

  dispatch({
    type: PROVIDER_SUGGESTIONS,
    payload: {
      client: 'azureProviderSearch',
      request: {
        method: 'get',
        url: `${Config.PROVIDER_URL_SUGGEST}?input=${input}&includeLocations=true`,
        params: {
          isSelectHealth
        }
      }
    }
  });
};
